/**
 * TodaysPromptCard - Featured prompt of the day
 *
 * Shows a random or featured prompt to inspire users to record
 * a reflection. Highlights with the app's signature yellow gradient.
 */

import React from 'react';

function TodaysPromptCard({ prompt, onRecord, onViewPrompts, categories }) {
  const category = categories?.find(c => c.slug === prompt?.category_slug);

  if (!prompt) {
    return (
      <div className="bento-card bento-card--large todays-prompt-card">
        <div className="bento-card-header">
          <h2 className="bento-card-title">
            <span className="bento-card-icon">💡</span>
            Today's Prompt
          </h2>
        </div>
        <div className="todays-prompt-content">
          <p className="todays-prompt-text" style={{ color: 'var(--color-text-secondary)' }}>
            No prompts available. Add your first prompt to get started!
          </p>
          <div className="todays-prompt-meta">
            <button
              className="btn btn--primary btn--pill"
              onClick={onViewPrompts}
            >
              View Prompts
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bento-card bento-card--large todays-prompt-card">
      <div className="bento-card-header">
        <h2 className="bento-card-title">
          <span className="bento-card-icon">💡</span>
          Today's Prompt
        </h2>
        <span className="view-all-link" onClick={() => onViewPrompts(prompt.category_slug)}>
          View More Prompts
        </span>
      </div>
      <div className="todays-prompt-content">
        <p className="todays-prompt-text">
          {prompt.prompt_text}
        </p>
        <div className="todays-prompt-meta">
          <span className="todays-prompt-category">
            {category && <span>{category.icon}</span>}
            {category?.name || prompt.category_slug}
          </span>
          <div className="todays-prompt-actions">
            <button
              className="btn btn--primary btn--pill"
              onClick={() => onRecord(prompt)}
            >
              Record Reflection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TodaysPromptCard;
